<template>
  <div class="flex items-center space-x-1">
    <button 
      class="toolbar-btn" 
      @click="$emit('open')" 
      :title="$t('Open')"
      v-if="false" 
    >
      <i class="fas fa-folder"></i>
    </button>
    <button v-if="false"
      class="toolbar-btn" 
      @click="$emit('save')" 
      :title="$t('Save')"
    >
      <i class="fas fa-save"></i>
    </button>
    <vs-dropdown v-if="false">
      <button class="toolbar-btn" :title="$t('Menu')">
        <i class="fas fa-bars"></i>
      </button>
      <vs-dropdown-menu>
        <vs-dropdown-item @click="$emit('share')">
          {{ $t('ShareOnboarding') }}
        </vs-dropdown-item>
        <vs-dropdown-item @click="$emit('assign')">
          {{ $t('AssignOnboarding') }}
        </vs-dropdown-item>
        <vs-dropdown-item @click="$emit('assign-role')">
          {{ $t('AssignToRoleTitle') }}
        </vs-dropdown-item>
        <vs-dropdown-item @click="$emit('add-space')">
          {{ $t('AddToSpace') }}
        </vs-dropdown-item>
        <vs-dropdown-item @click="$emit('properties')">
          {{ $t('OpenPropertiesMenu') }}
        </vs-dropdown-item>
        <vs-dropdown-item @click="$emit('delete')">
          {{ $t('DeleteOnboarding') }}
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <button
      v-if="false" 
      class="toolbar-btn" 
      @click="$emit('clear-all')" 
      :title="$t('Close')"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'FileOperationsButtons',
  props: {
    editor: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script> 
